import lazySizes from "lazysizes";

Object.assign(lazySizes.cfg, {
  // loadHidden: false
});

lazySizes.init();
